module.exports = __webpack_public_path__ + "img/green2_sl.20844d54.svg";